var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page__title"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("apply_page.form_title")) + " ")]), _c('div', {
    staticClass: "page__desc",
    domProps: {
      "innerHTML": _vm._s(_vm.getModuleConfig('apply_page.form_desc'))
    }
  }), _vm.getModuleConfig('apply_page.content') ? _c('div', {
    staticClass: "page__content",
    domProps: {
      "innerHTML": _vm._s(_vm.getModuleConfig('apply_page.content'))
    }
  }) : _vm._e(), _c('CouponFilters', {
    staticClass: "s-mb-3",
    attrs: {
      "options": _vm.filterOptions,
      "value": _vm.filter
    },
    on: {
      "input": _vm.handleFilterChange
    }
  }), _vm.isWaltilyProvider ? _c('div', {
    staticClass: "search s-space-x-2 s-mb-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.code,
      expression: "code"
    }],
    staticClass: "search__input",
    attrs: {
      "placeholder": "輸入優惠券代號"
    },
    domProps: {
      "value": _vm.code
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value;
      }
    }
  }), _c('SharedButton', {
    staticClass: "s-btn-bg-primary",
    attrs: {
      "size": "xs",
      "variant": "primary",
      "block": ""
    },
    on: {
      "click": _vm.takeCoupon
    }
  }, [_vm._v(" 領取 ")])], 1) : _vm._e(), _c('div', [_vm.showLoading ? _c('Loading', {
    attrs: {
      "loading-message": "載入中..."
    }
  }) : !_vm.showLoading && _vm.coupons.length > 0 ? _vm._l(_vm.coupons, function (coupon) {
    return _c('CouponCard', {
      key: coupon.id,
      attrs: {
        "coupon": coupon,
        "show-code": false,
        "button-text": coupon.button_text
      },
      on: {
        "exchange": _vm.applyCoupon
      }
    });
  }) : _c('CouponEmpty'), _c('Pagination', {
    attrs: {
      "total-page": _vm.lastPage
    },
    on: {
      "input": _vm.fetchCoupon
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 2), _c('CouponModal', {
    ref: "couponModal",
    attrs: {
      "coupon": _vm.selectedCoupon
    }
  }), _c('CouponModal', {
    ref: "tempCouponModal",
    attrs: {
      "redeem-code-bundle-id": _vm.selectedRedeemCodeBundleId
    },
    on: {
      "redeemed": _vm.redeemedImmediateUsageCoupon
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }